export const REQUIRED_MESSAGE = 'Required';
export const NON_NEGATIVE_INT_MESSAGE = 'Entry must be non-negative';
export const INT32_MIN = -2147483648;
export const INT32_MAX = 2147483647;
export const DECIMAL_MIN = -99999999999999;
export const DECIMAL_MAX = 99999999999999;
export const TIME_LESS_THEN_PREIVOUS = 'The selected time is less than the previous selection. Please ensure that the selected time is greater than the previous selection';
export const NUMBER_MESSAGE = 'Entry must be a number';
export const DUPLICATE = 'Duplicate present';